/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { WP_NEWS_URL } from 'config/apiPaths';

import { WordpressNewsResponse } from './types';

export const getNews = async (): Promise<WordpressNewsResponse[]> => {
  return axios.get<WordpressNewsResponse[]>(WP_NEWS_URL).then((response) => response.data);
};
